/** phoneme segments used by en_UK */
export const en_UK_segments = [
  'eɪ', 'aɪ', 'aʊ', 'eə', 'iə', 'ɔɪ', 'əʊ',
  'ɑː', 'ɒ', 'æ', 'ɐ', 'ɛ', 'ɜː', 'iː', 'i', 'ɪ', 'ɔː', 'uː', 'ʊ', 'ʌ',
  'dʒ', 'tʃ',
  'b', 'd', 'f', 'ɡ', 'h', 'j', 'k', 'l', 'm', 'n', 'ŋ', 'p', 'ɹ', 's', 'ʃ', 't', 'ð', 'θ', 'v', 'w', 'z', 'ʒ',
];
/** single character phonemes used by en_UK */
export const en_UK_ipa = [
  'ɑ', 'ɒ', 'æ', 'ɐ', 'ɛ', 'ɜ', 'i', 'ɪ', 'ɔ', 'u', 'ʊ', 'ʌ',
  'a' /* aɪ, aʊ */, 'e' /* eə */, 'ə' /* eə, iə, əʊ */,
  'b', 'd', 'f', 'ɡ', 'h', 'j', 'k', 'l', 'm', 'n', 'ŋ', 'p', 'ɹ', 's', 'ʃ', 't', 'ð', 'θ', 'v', 'w', 'z', 'ʒ',
  'ː' /* ɑː, ɜː, iː, ɔː, uː */, '\u200D' /* zero-width joiner used for diphthongs & affricates */,
];

/*
note that /i‍ə/ is the only diphthong that needs some sort of marking in the dictionary (like a ZWJ)
since it's separate syllables in words like <amiable>
*/


// data downloaded from: https://github.com/open-dict-data/ipa-dict/releases
export let en_UK_to_ipa: Record<string, string> = {};

/** set the UK dictionary */
export function setUKDictionary(data: Record<string, string>) {
  en_UK_to_ipa = data;
}
